import { __extends } from "tslib";
import Element from './element';
import { multiplyVec2 } from '../util/matrix';
var AbstractShape = /** @class */ (function (_super) {
    __extends(AbstractShape, _super);
    function AbstractShape(cfg) {
        return _super.call(this, cfg) || this;
    }
    // æ¯å¦å¨åå´çå
    AbstractShape.prototype._isInBBox = function (refX, refY) {
        var bbox = this.getBBox();
        return bbox.minX <= refX && bbox.maxX >= refX && bbox.minY <= refY && bbox.maxY >= refY;
    };
    /**
     * å±æ§æ´æ¹åéè¦åçäºæ
     * @protected
     * @param {ShapeAttrs} targetAttrs æ¸²æçå¾åå±æ§
     */
    AbstractShape.prototype.afterAttrsChange = function (targetAttrs) {
        _super.prototype.afterAttrsChange.call(this, targetAttrs);
        this.clearCacheBBox();
    };
    // è®¡ç®åå´çæ¶ï¼éè¦ç¼å­ï¼è¿æ¯ä¸ä¸ªé«é¢çæä½
    AbstractShape.prototype.getBBox = function () {
        var bbox = this.cfg.bbox;
        if (!bbox) {
            bbox = this.calculateBBox();
            this.set('bbox', bbox);
        }
        return bbox;
    };
    // è®¡ç®ç¸å¯¹äºç»å¸çåå´ç
    AbstractShape.prototype.getCanvasBBox = function () {
        var canvasBBox = this.cfg.canvasBBox;
        if (!canvasBBox) {
            canvasBBox = this.calculateCanvasBBox();
            this.set('canvasBBox', canvasBBox);
        }
        return canvasBBox;
    };
    AbstractShape.prototype.applyMatrix = function (matrix) {
        _super.prototype.applyMatrix.call(this, matrix);
        // æ¸çæç¼å­çåå´ç
        this.set('canvasBBox', null);
    };
    /**
     * è®¡ç®ç¸å¯¹äºç»å¸çåå´çï¼é»è®¤ç­åäº bbox
     * @return {BBox} åå´ç
     */
    AbstractShape.prototype.calculateCanvasBBox = function () {
        var bbox = this.getBBox();
        var totalMatrix = this.getTotalMatrix();
        var minX = bbox.minX, minY = bbox.minY, maxX = bbox.maxX, maxY = bbox.maxY;
        if (totalMatrix) {
            var topLeft = multiplyVec2(totalMatrix, [bbox.minX, bbox.minY]);
            var topRight = multiplyVec2(totalMatrix, [bbox.maxX, bbox.minY]);
            var bottomLeft = multiplyVec2(totalMatrix, [bbox.minX, bbox.maxY]);
            var bottomRight = multiplyVec2(totalMatrix, [bbox.maxX, bbox.maxY]);
            minX = Math.min(topLeft[0], topRight[0], bottomLeft[0], bottomRight[0]);
            maxX = Math.max(topLeft[0], topRight[0], bottomLeft[0], bottomRight[0]);
            minY = Math.min(topLeft[1], topRight[1], bottomLeft[1], bottomRight[1]);
            maxY = Math.max(topLeft[1], topRight[1], bottomLeft[1], bottomRight[1]);
        }
        var attrs = this.attrs;
        // å¦æå­å¨ shadow åè®¡ç® shadow
        if (attrs.shadowColor) {
            var _a = attrs.shadowBlur, shadowBlur = _a === void 0 ? 0 : _a, _b = attrs.shadowOffsetX, shadowOffsetX = _b === void 0 ? 0 : _b, _c = attrs.shadowOffsetY, shadowOffsetY = _c === void 0 ? 0 : _c;
            var shadowLeft = minX - shadowBlur + shadowOffsetX;
            var shadowRight = maxX + shadowBlur + shadowOffsetX;
            var shadowTop = minY - shadowBlur + shadowOffsetY;
            var shadowBottom = maxY + shadowBlur + shadowOffsetY;
            minX = Math.min(minX, shadowLeft);
            maxX = Math.max(maxX, shadowRight);
            minY = Math.min(minY, shadowTop);
            maxY = Math.max(maxY, shadowBottom);
        }
        return {
            x: minX,
            y: minY,
            minX: minX,
            minY: minY,
            maxX: maxX,
            maxY: maxY,
            width: maxX - minX,
            height: maxY - minY,
        };
    };
    /**
     * @protected
     * æ¸çç¼å­ç bbox
     */
    AbstractShape.prototype.clearCacheBBox = function () {
        this.set('bbox', null);
        this.set('canvasBBox', null);
    };
    // å®ç°æ¥å£
    AbstractShape.prototype.isClipShape = function () {
        return this.get('isClipShape');
    };
    /**
     * @protected
     * ä¸åçå¾å½¢èªå·±å®ç°æ¯å¦å¨å¾å½¢åé¨çé»è¾ï¼è¦å¤æ­è¾¹åå¡«ååºå
     * @param  {number}  refX ç¸å¯¹äºå¾å½¢çåæ  x
     * @param  {number}  refY ç¸å¯¹äºå¾å½¢çåæ  Y
     * @return {boolean} ç¹æ¯å¦å¨å¾å½¢åé¨
     */
    AbstractShape.prototype.isInShape = function (refX, refY) {
        return false;
    };
    /**
     * æ¯å¦ä»ä»ä½¿ç¨ BBox æ£æµå°±å¯ä»¥å¤å®æ¾åå°å¾å½¢
     * é»è®¤æ¯ falseï¼ä½æ¯æäºå¾å½¢ä¾å¦ imageãmarker ç­é½å¯ç´æ¥ä½¿ç¨ BBox çæ£æµèä¸éè¦ä½¿ç¨å¾å½¢æ¾å
     * @return {Boolean} ä»ä»ä½¿ç¨ BBox è¿è¡æ¾å
     */
    AbstractShape.prototype.isOnlyHitBox = function () {
        return false;
    };
    // ä¸åç Shape åèªå®ç°
    AbstractShape.prototype.isHit = function (x, y) {
        var startArrowShape = this.get('startArrowShape');
        var endArrowShape = this.get('endArrowShape');
        var vec = [x, y, 1];
        vec = this.invertFromMatrix(vec);
        var refX = vec[0], refY = vec[1];
        var inBBox = this._isInBBox(refX, refY);
        // è·³è¿å¾å½¢çæ¾åï¼å¨æäºå¾å½¢ä¸­å¯ä»¥çç¥ä¸åçæ£æµææ¬
        if (this.isOnlyHitBox()) {
            return inBBox;
        }
        // è¢«è£åæçåä¸å¨åå´çåçä¸è¿è¡è®¡ç®
        if (inBBox && !this.isClipped(refX, refY)) {
            // å¯¹å¾å½¢è¿è¡æ¾åå¤æ­
            if (this.isInShape(refX, refY)) {
                return true;
            }
            // å¯¹èµ·å§ç®­å¤´è¿è¡æ¾åå¤æ­
            if (startArrowShape && startArrowShape.isHit(refX, refY)) {
                return true;
            }
            // å¯¹ç»æç®­å¤´è¿è¡æ¾åå¤æ­
            if (endArrowShape && endArrowShape.isHit(refX, refY)) {
                return true;
            }
        }
        return false;
    };
    return AbstractShape;
}(Element));
export default AbstractShape;
//# sourceMappingURL=shape.js.map